<style scope></style>

<template>
  <div>

    <b-table :data="lista" :loading="loading" class="row-button"
             :narrowed="true" :striped="true">
      <portal-lista-vazia slot="empty"/>

      <template slot-scope="props">

        <b-table-column label="Pedido">
          {{ props.row.E1_PEDIDO }}
        </b-table-column>

        <b-table-column label="Cliente">
          {{ props.row.E1_CODCLI }}
        </b-table-column>

        <b-table-column label="Loja">
          {{ props.row.E1_LOJA }}
        </b-table-column>

        <b-table-column label="Nome do Cliente">
          {{ props.row.A1_NOME }}
        </b-table-column>

        <b-table-column label="Prefixo">
          {{ props.row.E1_PREFIXO }}
        </b-table-column>

        <b-table-column label="Número">
          {{ props.row.E1_NUM }}
        </b-table-column>

        <b-table-column label="Parcela">
          {{ props.row.E1_PARCELA }}
        </b-table-column>

        <b-table-column label="Emissao" >
          {{ props.row.E1_EMISSAO | moment("DD/MM/YYYY") }}
        </b-table-column>

        <b-table-column label="Vencimento" >
          {{ props.row.E1_VENCREA | moment("DD/MM/YYYY") }}
        </b-table-column>

        <b-table-column label="Vlr. Base">
          {{ props.row.E1_BASCOM1 | moeda }}
        </b-table-column>

        <b-table-column label="%">
          {{ props.row.E1_COMIS1 }}
        </b-table-column>

        <b-table-column label="Vlr. Comissão">
          {{ props.row.COMIS | moeda }}
        </b-table-column>
      </template>

      <template slot="footer">
        <div class="has-text-right">

          <div class="columns">
            <div class="column p-b-0">
              Total:
            </div>
            <div class="column is-1 p-b-0">
              {{valorTotal | moeda}}
            </div>
          </div>
        </div>
      </template>

    </b-table>

  </div>
</template>

<script>
  export default {
    props: ['lista', 'loading', 'valorTotal']
  }
</script>



// WEBPACK FOOTER //
// src/pages/comissao/ListaComissaoPrevista.vue